import { ITEMS_RARITY, ITEMS_TIME_BOOSTERS_CATEGORIES, ItemTemplate } from "../constants";

export default {
    type: "time_boosters",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "seconds",
        "label": "Duration",
    }, {
        "key": "group",
        "label": "Type",
    }, {
        "key": "multiplier",
        "label": "Multiplier",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "seconds",
        "label": "Duration time in seconds",
        "type": "input",
        "format": "integer",
        "disabled": true
    }, {
        "key": "multiplier",
        "label": "Multiplier",
        "type": "input",
        "format": "integer"
    }, {
        "key": "group",
        "label": "Type",
        "type": "select",
        "values": ITEMS_TIME_BOOSTERS_CATEGORIES
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
